import {  createSlice} from '@reduxjs/toolkit';

//import {AppThunk} from '../../store';
const initialAuthState = {
  isLogin: false,
  token: null,
  isLoading: false,
  error: '',
  onboardCompleted: false,
  isForgotPasswordFlow: null
};

/**
 * Thunks Actions
 * Reducers
 */
const authReducer = createSlice({
  name: 'authToken',
  initialState: initialAuthState,
  reducers: {
 
  },
  extraReducers: (builder) => {
  },
});

/*Actions export*/
const {} = authReducer.actions;
export {};
/*Reducer export*/
export default authReducer;
